import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Copy } from "lucide-react"; // For copy icon
import { getImage } from '../Utils/image_helper';
import { Referral } from '../components/Referral';
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Languages } from "../Utils/Languages";
import { ConfigContext } from '../context/GlobalContext';
import SyncReferralMapping from '../data/Firebase/User/SyncReferralMapping';
import GetUserDataFirebase from '../data/Firebase/User/GetUserDataFirebase';
import * as actionType from "../context/actions";


export const ReferralPage = () => {
    const [copied, setCopied] = useState(false);
    const { state, dispatch } = useContext(ConfigContext);

    const hasSynced = React.useRef(false);

    React.useEffect(() => {
        const syncData = async () => {
            if (state?.USERID && !hasSynced.current) {
                hasSynced.current = true;
                const userdata = await GetUserDataFirebase(state.USERID);

                dispatch({
                    type: actionType.SET_USER,
                    payload: {
                        ...state?.SET_USER,
                        referral_code: userdata?.referral_code
                    }
                });
                SyncReferralMapping(state.USERID, userdata, dispatch);
            }
        };
        syncData();
    }, [state?.USERID]);

    return (
        <MasterLayout>

            {/* Breadcrumb */}
            <Breadcrumb title={"Referral Page"} />

            {/* InvoiceListLayer */}
            <Referral />

        </MasterLayout>
    );
};
